<!--
� 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
-->

<div
	class="drag-container"
	[ngClass]="{ 'dragging-over': isDraggingOver, 'has-uploaded': hasUploaded, fluid: fluid }"
	(dragenter)="onDragEnter($event)"
	(dragend)="onDragLeave($event)"
	(dragover)="onDragOver($event)"
	(dragleave)="onDragLeave($event)"
	(drop)="onDrop($event)"
>
	@if (hasUploaded) {
		<span
			class="no-drag-if-uploaded-message"
			[ngClass]="{ 'is-visible': isDraggingOver }"
		>
			Please remove the uploaded file to upload another one.
		</span>

		<div
			class="upload-status"
			[ngClass]="{ 'is-hidden': isDraggingOver }"
		>
			<span class="icon-upload"></span>

			<div class="file-upload-status">
				<div class="file-info">
					<span class="file-name">{{ uploadedFileName }}</span>

					@if (hasUploadingError || hasUploadedWithSuccess) {
						<globalictcc-button
							[iconOnly]="true"
							iconName="delete"
							(handleClick)="onRemoveFile()"
						/>
					}
				</div>

				<globalictcc-progress-bar
					[percentage]="uploadingPercentage"
					[color]="hasUploadingError || errorMessage ? colors.ORANGE_50 : colors.GREEN"
				/>

				@if (hasUploadingError || errorMessage) {
					<span class="uploading-error-message">
						{{ errorMessage || "Someting went wrong" }},
						<globalictcc-button
							label="Try again"
							(handleClick)="onUploadFile()"
							[textOnly]="true"
						/>
					</span>
				} @else {
					@if (hasUploadedWithSuccess) {
						<div class="uploading-success">
							<span class="uploading-message">Successfully uploaded!</span>

							<span class="icon-checkmark"></span>
						</div>
					} @else {
						<div class="loading">
							<span class="uploading-message">Loading...</span>

							<span class="percentage">
								{{ uploadingPercentage | maxDecimals: 2 }}%
							</span>
						</div>
					}
				}
			</div>
		</div>
	} @else {
		<span class="icon-upload"></span>

		<span class="drag-text">
			Drag and drop your file here or

			<globalictcc-button
				label="Click here"
				[textOnly]="true"
				(handleClick)="onUploadFile()"
			/>

			to upload
		</span>

		<span class="drag-hint">
			Supported format
			{{ acceptedFilesExtensions.length ? acceptedFilesExtensions.join(", ") : "(all)" }}
			(Max 10mb)
		</span>
	}
</div>

<input
	#fileUpload
	type="file"
	class="file-upload"
	[accept]="acceptedFilesExtensions"
	(change)="onFileSelected($event)"
/>
